export * from './testing/server';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
